import { SlotOpsTimeSettings, SlotOpsTimeSettingsUpdate } from '../../Model/SlotOpsTimeSettings';
import { AccountRepository } from '../Repositories/AccountRepository';

export class UpdateSlotOpsTimeSettingsUseCase {
  constructor(private repo: AccountRepository) {}

  execute(dto: SlotOpsTimeSettingsUpdate): Promise<SlotOpsTimeSettings> {
    return this.repo.updateSlotOpsTimeSettings(dto);
  }
}
